import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { RestTurnStepScheduleModel } from '@main-application/boards/interfaces/board';
import { parseNumber } from '@shared/functions/parse-number';

export interface ScheduleAmountDialogData {
  cellData: RestTurnStepScheduleModel;
}

export interface ScheduleAmountDialogResult {
  amount?: number;
}

@Component({
  selector: 'app-schedule-amount-dialog',
  templateUrl: './schedule-amount-dialog.component.html',
  styleUrls: ['./schedule-amount-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ScheduleAmountDialogComponent implements OnInit, AfterViewInit {
  data: ScheduleAmountDialogData;
  amount?: number;

  @ViewChild('input', { read: ElementRef }) input: ElementRef<HTMLInputElement>;

  constructor(
    public dialogRef: MatDialogRef<ScheduleAmountDialogComponent, ScheduleAmountDialogResult>,
    protected store: Store<{}>,
    protected cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) data: ScheduleAmountDialogData
  ) {
    this.data = data;
    this.amount = data.cellData.amount;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.input.nativeElement.select();
    }, 0);
  }

  cancel() {
    this.dialogRef.close();
  }

  send(value: string) {
    this.dialogRef.close({
      amount: parseNumber(value),
    } as ScheduleAmountDialogResult);
  }

  keyUp($event: KeyboardEvent, input: HTMLInputElement) {
    if (input.value === '' && $event.key === '.') {
      input.value = '0.';
    }
  }
}
